module.exports = __webpack_public_path__ + "b13697c95a6f519b523c5569582c9535.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/doctor-bag.png
// module id = 2997
// module chunks = 0